import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import logoSiloam from "../../assets/logo_siloam.png";
import bg from "../../assets/bg_sos.jpg";
import imgHeader from "../../assets/header_sos.png";
import PopupAdd from "../../components/popup_add";
import CONFIG from "../../constanta/config";
import ModalImage from "react-modal-image";

const PageSymposium = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="relative w-full md:w-[500px] mx-auto h-screen flex flex-col justify-betwstarteen items-start ">
        <img
          src={bg}
          className="absolute z-10 w-full h-full mx-auto object-cover"
          alt=""
        />

        <img
          src={imgHeader}
          className="absolute z-50 top-0 w-full object-contain mx-auto object-cover"
          alt=""
        />

        <div className="overflow-x-hidden z-10 relative flex flex-grow w-full h-auto justify-center items-start px-5 pb-5 pt-20">
          <div className="flex flex-col justify-center items-center pb-20 w-full space-y-6">
            <div className="w-full h-auto bg-white border-2 border-white rounded-lg p-2 ">
              <div className="font-bold text-lg text-center">SYMPOSIUM</div>
            </div>

            <div className="w-full h-auto bg-white border-2 border-white rounded-lg p-4 ">
              <ModalImage
                small={CONFIG.URL_MEDIA + "/Leaflet_Oncology 2024_IG Feed_rev0204_page-0001.jpg"}
                large={CONFIG.URL_MEDIA + "/Leaflet_Oncology 2024_IG Feed_rev0204_page-0001.jpg"}
                alt=""
              />

              <div className="w-full mt-4">
                <a
                  href={CONFIG.URL_MEDIA + "/Leaflet_Oncology 2024_IG Feed_rev0204.pdf"}
                  target="_blank"
                  rel="noreferrer"
                >
                  <button className="w-full px-5 py-2 bg-transprent border-2 border-[#0d132a] rounded-lg text-[#0d132a] font-bold">
                    OPEN PDF
                  </button>
                </a>
              </div>
            </div>

            <div className="w-full h-auto bg-white border-2 border-white rounded-lg p-4 ">
              <div className="w-full h-auto bg-white border-2 border-white rounded-lg mb-5">
                <div className="font-bold text-lg text-left uppercase">
                  {" "}
                  Rundown Day 1
                </div>
              </div>

              <ModalImage
                small={
                  CONFIG.URL_MEDIA + "/Rundown Onco Summit_Day 1_rev-1_page-0001.jpg"
                }
                large={
                  CONFIG.URL_MEDIA + "/Rundown Onco Summit_Day 1_rev-1_page-0001.jpg"
                }
                alt=""
              />

              <ModalImage
                small={
                  CONFIG.URL_MEDIA + "/Rundown Onco Summit_Day 1_rev-1_page-0002.jpg"
                }
                large={
                  CONFIG.URL_MEDIA + "/Rundown Onco Summit_Day 1_rev-1_page-0002.jpg"
                }
                alt=""
              />

              <div className="w-full mt-4">
                <a
                  href={CONFIG.URL_MEDIA + "/Rundown Onco Summit_Day 1_rev-1.pdf"}
                  target="_blank"
                  rel="noreferrer"
                >
                  <button className="w-full px-5 py-2 bg-transprent border-2 border-[#0d132a] rounded-lg text-[#0d132a] font-bold">
                    OPEN PDF
                  </button>
                </a>
              </div>
            </div>

            <div className="w-full h-auto bg-white border-2 border-white rounded-lg p-4 ">
              <div className="w-full h-auto bg-white border-2 border-white rounded-lg mb-5">
                <div className="font-bold text-lg text-left uppercase">
                  {" "}
                  Rundown Day 2
                </div>
              </div>

              <ModalImage
                small={
                  CONFIG.URL_MEDIA + "/Rundown Onco Summit_Day 2_rev-1_page-0001.jpg"
                }
                large={
                  CONFIG.URL_MEDIA + "/Rundown Onco Summit_Day 2_rev-1_page-0001.jpg"
                }
                alt=""
              />

              <ModalImage
                small={
                  CONFIG.URL_MEDIA + "/Rundown Onco Summit_Day 2_rev-1_page-0002.jpg"
                }
                large={
                  CONFIG.URL_MEDIA + "/Rundown Onco Summit_Day 2_rev-1_page-0002.jpg"
                }
                alt=""
              />

              <div className="w-full mt-4">
                <a
                  href={CONFIG.URL_MEDIA + "/Rundown Onco Summit_Day 2_rev-1.pdf"}
                  target="_blank"
                  rel="noreferrer"
                >
                  <button className="w-full px-5 py-2 bg-transprent border-2 border-[#0d132a] rounded-lg text-[#0d132a] font-bold">
                    OPEN PDF
                  </button>
                </a>
              </div>
            </div>

            <div className="w-full flex justify-center items-center space-x-5 my-5">
              <button
                onClick={() => navigate("/event-info")}
                className="w-full px-5 py-2 bg-transprent border-2 border-red-500 rounded-lg text-white font-bold"
              >
                BACK
              </button>
            </div>
          </div>
        </div>

       
      </div>
    </>
  );
};

export default PageSymposium;
